import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import { Locale } from '@/lib/enums/locale.enum';
import { Resource } from 'i18next/typescript/options';

type I18nInstance = ReturnType<typeof createInstance>;

type Props = {
  locale: Locale;
  dictionary: Resource;
  instance?: I18nInstance;
  defaultNamespace?: string;
};

export type DictionaryInit = {
  i18n: I18nInstance;
  t: I18nInstance['t'];
};

export const initDictionary = async (props: Props): Promise<DictionaryInit> => {
  const instance = props.instance || createInstance();

  instance.use(initReactI18next);
  await instance.init({
    lng: 'en', // if you're using a language detector, do not define the lng option
    resources: props.dictionary,
    fallbackLng: 'en',
    defaultNS: props.defaultNamespace ?? 'common',
    debug: process.env.NEXT_PUBLIC_ENABLE_DICTIONARY_DEBUG === 'true',
  });

  return {
    i18n: instance,
    t: instance.t,
  };
};
